import { useRef } from 'react'

const isDeviceIOS = () => /iPhone|iPad|iPod/.test(navigator.userAgent)

export const useChatMessagesScroll = () => {
  const currentChatRef = useRef<HTMLDivElement>(null)

  const iosScrollToBottom = (): void => {
    const lastMessage = document.getElementById('message-0') as HTMLDivElement
    if (lastMessage) {
      lastMessage.scrollIntoView({ behavior: 'smooth', block: 'end' })
    }
  }

  const androidScrollToBottom = (): void => {
    if (!currentChatRef?.current) return
    const chatRef = currentChatRef.current

    if (chatRef.scrollTo) {
      chatRef.scrollTo({
        top: chatRef.scrollHeight,
        behavior: 'smooth'
      })
    }
  }

  const scrollMessageToBottom = () => {
    if (isDeviceIOS()) {
      iosScrollToBottom()
      return
    }
    androidScrollToBottom()
  }

  return {
    currentChatRef,
    scrollMessageToBottom
  }
}
